var map = {
	"./alaska.jpg": 2012,
	"./calculate.svg": 5547,
	"./cosmopack.svg": 7149,
	"./mdm.png": 1727,
	"./okilsato.svg": 1443,
	"./pechatnik.png": 3396,
	"./pechatnik2.png": 3868,
	"./plasticKit.svg": 7509,
	"./protei.svg": 5732,
	"./rpkr.png": 7826,
	"./stickyline.png": 1008,
	"./suppler_demo.png": 5518,
	"./upakovka24.svg": 4503,
	"./vitaplast.svg": 4641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5564;